export type { GetInternalLink, ncCampaignType } from './types';
export { getInternalLink } from './utils';
